import React from 'react';
import { Form, Select } from 'antd';
import { usePmCode } from 'hooks';
import { selectBoxFilterOption } from 'utils/form-utils';

interface FormItemProps {
  fieldname: string
  required?: boolean
  pm?: string
  mode?: any
}

const PmFormItem = ({fieldname, required = false, pm, mode=undefined}: FormItemProps): React.ReactElement => {
  /* ======================================================
   * variables
   * ====================================================== */

  /* ======================================================
  * hooks
  * ====================================================== */
  const { pmCodeList } = usePmCode({include:pm});  

  /* ======================================================
  * events
  * ====================================================== */  

  /* ======================================================
  * effects
  * ====================================================== */  

  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <>
        <Form.Item name={fieldname} style={{ width:'180px', display: 'inline-block'}} rules={[{ required: required, message: '' }]}>
          <Select 
            showSearch
            placeholder="PM 선택" 
            mode={mode}
            allowClear 
            optionFilterProp="label"
            filterOption={selectBoxFilterOption}
            options={pmCodeList} />     
        </Form.Item>
    </>
  );
};

export default PmFormItem;
